<template>
    <div class="tab-content">
      <el-tabs activeName="first">
        <el-tab-pane :label="$t('e_tab_meetings_first')" name="first">
          <el-card>
            <div class="add-meeting-btn">
                <el-button :disabled="!engagementPermission.setMeetings" @click="addMeetingOpen" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('e_tab_meetings_first_btn_setMeeting')}}</el-button>
            </div>
            <div class="my-window">
              <input ref='fileMeetingTab' v-show="false" @change="handleMeetingFileTab" id="fileMeetingTab" name="fileMeetingTab" type="file">

              <div v-for="meeting in engagementMeetings" :key="meeting.id" :id="meeting.id">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <div>
                      <div>{{$t('e_tab_meetings_first_card_title')}}: <b>{{meeting.name}}</b></div>
                      <div style="margin-top:5px;">{{$t('e_tab_meetings_first_card_roomId')}}: <b>{{meeting.roomVideoId}}</b></div>
                    </div>
                    <div style="display:flex; justify-content: flex-end">
                      <el-button
                          v-if="meeting.status !== 3"
                          size="mini"
                          plain
                          icon="el-icon-message"
                          @click="sendMeetingLink(meeting)">
                      </el-button>
                      <el-button
                          v-if="meeting.status !== 3"
                          style="margin-right:10px;"
                          size="mini"
                          plain
                          @click="copySharedLink(meeting)">
                        {{$t('general_copyMeetingLink')}}
                      </el-button>
                      <div class="first-action-block" v-if="!firstStepDone(meeting.companyUserList)" style="margin-right:10px;">
                        <el-button
                            :disabled="meeting.startTimestamp < moment().format('X')"
                            v-if="meeting.notAprroved"
                            size="mini"
                            plain
                            @click="accept(meeting.id)">
                          {{$t('e_tab_meetings_first_card_approve')}}
                        </el-button>
                        <el-button
                            :disabled="meeting.startTimestamp < moment().format('X')"
                            v-if="!checkIfTentativeClicked(meeting.companyUserList)"
                            size="mini"
                            plain
                            @click="tentative(meeting.id)">
                          {{$t('e_tab_meetings_first_card_tentative')}}
                        </el-button>
                        <el-button
                            :disabled="meeting.startTimestamp < moment().format('X')"
                            v-if="meeting.notAprroved"
                            size="mini"
                            plain
                            @click="decline(meeting.id)">
                          {{$t('e_tab_meetings_first_card_decline')}}
                        </el-button>
                      </div>
                      <div style="display:flex; align-items:center; margin-right:10px;">
                        <el-button
                            v-if="meeting.status === 1 && !meeting.notAprroved && companyLayout.companyUserId === meeting.hostId"
                            size="mini"
                            plain
                            @click="openMeeting(meeting)">
                          {{isLateMeeting(meeting)  ? $t('e_tab_meetings_first_card_late') : $t('e_tab_meetings_first_card_open')}}
                        </el-button>
                        <span v-if="isLateMeeting(meeting) && showLateButton(meeting)" style="margin-left:5px;margin-right:5px;">{{$t('e_tab_meetings_first_card_or')}}</span>
                        <el-button
                            v-if="showLateButton(meeting)"
                            size="mini"
                            plain
                            @click="openLateMeetingModal(meeting)">
                          {{$t('e_tab_meetings_first_card_shiftMeeting')}}
                        </el-button>
                      </div>
                      <el-button
                          v-if="showGoToMeetingButton(companyLayout.companyUserId, meeting)"
                          size="mini"
                          plain
                          @click="startMeeting(meeting)">
                        <font-awesome-icon icon="comments"/>
                      </el-button>
                      <el-button
                          v-if="meeting.status === 2 && companyLayout.companyUserId === meeting.hostId"
                          size="mini"
                          plain
                          @click="closeMeeting(meeting.id)">
                        {{$t('e_tab_meetings_first_card_close')}}
                      </el-button>
                      <el-button
                          v-if="meeting.status === 3"
                          size="mini"
                          plain
                          disabled>
                        {{$t('e_tab_meetings_first_card_closed')}}
                      </el-button>
                      <el-button
                          v-if="!hideEditMeeting(meeting)"
                          size="mini"
                          plain
                          @click="editTeamMeetingOpen(meeting)"
                          :disabled="meeting.status === 2 || meeting.status === 3">
                        {{$t('e_tab_meetings_first_card_editTeam')}}
                      </el-button>
                      <el-button
                          v-if="!hideEditMeeting(meeting)"
                          size="mini"
                          icon="el-icon-edit"
                          plain
                          @click="editMeetingOpen(meeting.id)"
                          :disabled="meeting.status === 2 || meeting.status === 3"></el-button>
                      <el-button
                          v-if="!hideDeleteMeeting(meeting)"
                          size="mini"
                          icon="el-icon-delete"
                          plain
                          @click="handleDelete(meeting.id)"
                          :disabled="meeting.status === 2"></el-button>
                      <el-button
                          size="mini"
                          icon="el-icon-refresh-left"
                          :loading="refreshLoading"
                          plain
                          @click="refreshMeetingsList()"></el-button>
                    </div>
                  </div>

                  <el-row :span="24" :gutter="20" class="meeting-info">
                    <el-col :span="12" class="main-info-block">
                      <div class="text item">
                        {{$t('e_tab_meetings_first_card_start')}}: <span class="date">{{moment(meeting.startTimestamp, 'X').format('DD MMMM YYYY LT')}}</span>
                      </div>
                      <div class="text item">
                        {{$t('e_tab_meetings_first_card_duration')}}: <span class="date">{{secondsToHms(meeting.meetingDuration)}}</span>
                      </div>
                      <div class="team-block">
                        <el-row :span="24" :gutter="5">
                          <el-col :span="3">{{$t('e_tab_meetings_first_card_host')}}:</el-col>
                          <el-col :span="9">{{meeting.companyUser.user.fullName}}</el-col>
                          <el-col :span="6"></el-col>
                          <el-col :span="6"></el-col>
                        </el-row>
                        <el-row style="display:flex; align-items:center;" :span="24" :gutter="2" v-for="(user, index) in meeting.companyUserList.filter(val => val.companyUser.id !== meeting.companyUser.id)" :key="index">
                          <el-col :span="3"><span v-if="!index">{{$t('e_tab_meetings_first_card_team')}}:</span><span><br></span></el-col>
                          <el-col :span="9">
                            {{user.companyUser.user.fullName}}</el-col>
                          <el-col :span="6">
                            <span v-if="user.approved">{{$t('e_tab_meetings_first_card_yes')}}</span>
                            <span v-else-if="user.decline">{{$t('e_tab_meetings_first_card_no:')}}</span>
                            <span v-else-if="user.tentative">{{$t('e_tab_meetings_first_card_maybe')}}</span>
                            <span v-else>{{$t('e_tab_meetings_first_card_invited')}}</span>
                          </el-col>
                          <el-col :span="6"></el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="12" class="shift-block" v-if="meeting.oldDate">
                      <div class="text item">
                        {{$t('e_tab_meetings_first_card_shiftedFrom')}}: <span class="date">{{moment(meeting.oldDate, 'X').format('DD MMMM YYYY HH:mm')}}</span>
                      </div>
                      <div class="reason-block">
                        {{$t('e_tab_meetings_first_card_reason')}}: {{meeting.reason}}
                      </div>
                    </el-col>
                  </el-row>

                  <el-row span="24" style="display:flex;align-items:center;">
                    <el-col :span="6">
                      {{$t('e_tab_meetings_first_card_status')}}:
                    </el-col>
                    <el-col :span="6">
                      <div>
                        <el-tag
                            v-if="meeting.status === 1"
                            type="warning"
                            effect="plain">
                          {{$t('e_tab_meetings_first_card_pending')}}
                        </el-tag>
                        <el-tag
                            v-if="meeting.status === 2"
                            type=""
                            effect="plain">
                          {{$t('e_tab_meetings_first_card_started')}}
                        </el-tag>
                        <el-tag
                            v-if="meeting.status === 3"
                            type=""
                            effect="plain">
                          {{$t('e_tab_meetings_first_card_closed')}}
                        </el-tag>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row span="24" style="margin-top:10px;display:flex;align-items:center;">
                    <el-col :span="6">
                      {{$t('e_tab_meetings_first_card_recorded')}}:
                    </el-col>
                    <el-col :span="6">
                      <el-tag
                          type="warning"
                          effect="plain">
                        {{$t('e_tab_meetings_first_card_noNo')}}
                      </el-tag>
                    </el-col>
                  </el-row>
                  <el-row span="24" style="margin-top:10px;display:flex;align-items:center;">
                    <el-col :span="6">
                      {{$t('e_tab_meetings_first_card_allowEarlyEntry')}}:
                    </el-col>
                    <el-col :span="6">
                      <el-tag
                          v-if="meeting.allowTeamJoinMeeting === 0"
                          type="warning"
                          effect="plain">
                        {{$t('e_tab_meetings_first_card_noNo')}}
                      </el-tag>
                      <el-tag
                          v-else
                          type=""
                          effect="plain">
                        {{$t('e_tab_meetings_first_card_yesYes')}}
                      </el-tag>
                    </el-col>
                  </el-row>
                  <el-collapse style="margin-top:10px;">
                    <el-collapse-item :title="$t('e_tab_meetings_first_card_purpose') + ':'" name="1">
                      <div v-html="meeting.purpose"></div>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('e_tab_meetings_first_card_agenda')  + ':'" name="2">
                      <el-card>
                        <div v-html="meeting.agenda"></div>
                      </el-card>
                      <el-button :disabled="disableClickNotesButton(meeting.agendaArr, meeting.creatorCompanyUserId)" size="mini" type="primary" class="button" @click="clickNotes(meeting)" style="margin-top:10px;">{{$t('e_tab_meetings_addNotes')}}</el-button>
                      <el-timeline style="margin-top:10px; padding-left:0;">
                        <el-timeline-item v-for="(agenda, index) in meeting.agendaArr" :key="index" :timestamp="moment(agenda.createDate.toString(), 'X').format('LLLL')" placement="top">
                          <el-card>
                            <div class="agenda-header">
                              <h4 style="margin:0;">{{agenda.user.fullName}}</h4>
                              <div>
                                <el-button
                                    size="mini"
                                    icon="el-icon-edit"
                                    v-if="isCurrentUserHaveAccess(agenda)"
                                    @click="updateAgendaOpenModal(agenda)"
                                    plain>
                                </el-button>
                                <el-button
                                    size="mini"
                                    icon="el-icon-delete"
                                    v-if="isCurrentUserHaveAccess(agenda)"
                                    @click="deleteAgenda(agenda)"
                                    plain>
                                </el-button>
                              </div>
                            </div>
                            <div v-html="agenda.agenda"></div>
                          </el-card>
                        </el-timeline-item>
                      </el-timeline>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('e_tab_meetings_first_card_file') + ':'" name="3">
                      <el-button size="mini" type="primary" class="button" @click="addFiles(meeting)" style="margin-top:10px;">{{$t('e_tab_meetings_addFiles')}}</el-button>
                      <!--TODO main meeting file future fix-->
                      <div class="main-files-block" style="margin-top:10px;">
                        <el-card>
                          <div v-if="meeting.filesMeetings.length">
                            <div v-for="(file, index) in meeting.filesMeetings" class="file__item" :key="file.id">
                              <div class="file__item__viewed">
                            <span @click="viewFile(file.url)">
                              <span style="margin-right: 5px;">{{index + 1}}.</span>
                               <span class="file__name">{{file.originalName}}</span>
                            </span>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div v-for="companyUser in meeting.companyUserList" class="file__item-block" :key="companyUser.id">
                              <div v-if="companyUser.meetingFiles.length" class="file__item-block__creator" style="font-weight: bold;">{{companyUser.companyUser.user.fullName}}</div>
                              <div class="file__item__viewed" v-for="(file2, index3) in companyUser.meetingFiles" :key="file2.id">
                                <span @click="viewFile(file2.url)">
                                  <span style="margin-right: 5px;">{{index3 + 1}}.</span>
                                  <span style="margin-right: 5px;" class="file__name">{{file2.originalName}}</span>
                                  <span class="file__timestamp">{{moment(file2.createDate).format('DD/MM/YY LT')}}</span>
                                </span>
                                <div class="file__delete" @click="deleteFile(file2, meeting)"><i class="el-icon-close"></i></div>
                              </div>
                            </div>
                          </div>

                        </el-card>
                      </div>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('e_tab_meetings_first_card_declines') + ':'" name="4">
                      <el-timeline style="margin-top:10px; padding-left:0;">
                        <el-timeline-item v-for="(decline, index) in meeting.companyUserList.filter(val => val.decline === 1)" :key="index" :timestamp="moment(decline.declineDate.toString(), 'X').format('LLLL')" placement="top">
                          <el-card>
                            <div class="agenda-header">
                              <h4 style="margin:0;">{{decline.companyUser.user.fullName}}</h4>
                            </div>
                            <div>{{decline.reason}}</div>
                          </el-card>
                        </el-timeline-item>
                      </el-timeline>
                    </el-collapse-item>
                  </el-collapse>
                </el-card>
              </div>
              <!-- <infinite-loading
                  @infinite="infiniteHandler"
                  ref="infiniteLoading">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
              </infinite-loading> -->
            </div>

            <createMeetingModal
                    :vendorsList="engagementCompanyVendorList"
                    :clientsList="engagementCompanyClientList"
                    :meetingType="meetingType"
                    :fileMeetingType="fileMeetingType"
                    :page="page"
                    ref="createMeetingModal"/>

            <edit-team-meeting-modal :meetingType="meetingType" ref="editTeamMeetingModal" :page="page"/>

            <late-meeting-modal :meetingType="meetingType" ref="lateMeetingModal" :page="page"/>


            <sweet-modal blocking ref="addNote" :title="$t('e_tab_meetings_first_card_addNote')" v-on:close="closeAgendaModal">
              <el-form :model="addNoteForm" ref="addNoteForm" class="demo-dynamic">
                <el-form-item
                    prop="agenda"
                    :rules="[
                      { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'blur' }
                    ]"
                >
                  <vue2-custom-editor
                      ref="editor"
                      v-model="addNoteForm.agenda">
                  </vue2-custom-editor>
                </el-form-item>
                <el-button style="margin-top:10px;" class="button" @click="addNoteFormSend('addNoteForm')">{{this.$t('general_add')}}</el-button>
              </el-form>
            </sweet-modal>

            <sweet-modal blocking ref="updateNote" :title="$t('engagement_tab_meetings_editNote')" v-on:close="closeUpdateAgendaModal">
              <el-form :model="updateNoteForm" ref="updateNoteForm" class="demo-dynamic">
                <el-form-item
                    prop="agenda"
                    :rules="[
                      { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'blur' }
                    ]"
                >
                  <vue2-custom-editor
                      ref="editor"
                      v-model="updateNoteForm.agenda">
                  </vue2-custom-editor>
                </el-form-item>
                <el-button style="margin-top:10px;" class="button" @click="updateNoteFormSend('updateNoteForm')">{{this.$t('general_save')}}</el-button>
              </el-form>
            </sweet-modal>
          </el-card>
        </el-tab-pane>
      </el-tabs>
<!--        <div class="book-mark-block pointer">-->
<!--          <div>-->
<!--            <div v-if="bookmarkListEngagement.meetings" @click="changeBookMarkEngagement(bookmarkListEngagement.meetings, $route.query.companyId, selectedRow.engagementId)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--            <div v-else @click="changeBookMarkEngagement(bookmarkListEngagement.meetings, $route.query.companyId, selectedRow.engagementId)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--          </div>-->
<!--        </div>-->

      <!--VIEWER-->
      <div v-if="viewerType == 1">
        <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
          <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
        </sweet-modal>
      </div>
      <div v-if="viewerType == 2">
        <div v-show="false" class="images" v-viewer="{movable: true}">
          <img :src="fileUrl" :key="fileUrl" />
        </div>
      </div>
      <div class="mod" v-if="viewerType == 3">
        <div @click="closeMod" class="mod__close">
          <span>x</span>
        </div>
        <Media
            :kind="'video'"
            :controls="true"
            :src="fileUrl"
        >
        </Media>
      </div>
      <div class="mod" v-if="viewerType == 4">
        <div @click="closeMod" class="mod__close">
          <span>x</span>
        </div>
        <Media
            :kind="'audio'"
            :controls="true"
            :src="fileUrl"
        >
        </Media>
      </div>

      <sweet-modal :title="$t('general_sendMeetingLink')" width="700" blocking ref="addEmail" v-on:close="closeAddEmailModal">
        <el-tag
          :key="tag"
          v-for="tag in dynamicTags"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)">
          {{tag}}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="mini"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        >
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ Email</el-button>

        <el-row :gutter="20" style="margin-top: 20px; text-align: right;">
          <el-col :span="24" :offset="0">
            <el-button @click="modalCancel('addEmail')">{{$t('general_cancel')}}</el-button>
            <el-button @click="sendMeetingLinkSubmit()" type="primary">{{$t('general_submit')}}</el-button>
          </el-col>
        </el-row>

      </sweet-modal>
    </div>
</template>

<script>
  import Media from '@dongido/vue-viaudio'
  import createMeetingModal from '@/components/Projects/meetings/createMeetingModal.vue'
  import moment from 'moment'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import axios from 'axios'
  import EditTeamMeetingModal from "../Projects/meetings/editTeamMeetingModal";
  import LateMeetingModal from "../Projects/meetings/lateMeetingModal";
  import Vue2CustomEditor from "../vue-2-custom-editor";
  import {viewEditFileMixin} from "../../mixins/viewEditFileMixin";
  export default  {
    name:'engagement-meeting-tab',
    computed:{
      engagementMeetings(){
        // return this.$store.state.engagementMeetings
        return this.$store.state.meetings
      },
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    mixins: [viewEditFileMixin],
    data(){
      return{
        dynamicTags: ['test@gmail.com'],
        inputVisible: false,
        inputValue: '',
        inviteLink: '',
        meetingName: '',
        meetingStartTime: '',

        companyUserId: '',
        moment:moment,
        selectedMeetingId: '',
        activeStar: 'el-icon-star-on',
        notActiveStar: 'el-icon-star-off',
        // viewerType: 0,
        // fileUrl: '',
        // type: '',
        activeMeetingId: null,
        addNoteForm: {
          agenda: null,
          meetingId: null
        },
        updateNoteForm: {
          agendaId: null,
          agenda: null,
          meetingId: null
        },
        refreshLoading: false,
        meetingType: 3,
        fileMeetingType: 13,
        page: 1,
      }
    },
    props: ['selectedRow', 'bookmarkListEngagement', 'engagementPermission', 'engagementCompanyVendorList', 'engagementCompanyClientList'],
    components:{
      Vue2CustomEditor,
      LateMeetingModal,
      EditTeamMeetingModal,
      SweetModal,
      Media,
      createMeetingModal
    },
    mounted(){
    },
    methods:{
      infiniteHandler($state){
        this.page += 1
        this.$store.dispatch('getMeetings', {
          companyId: this.$route.query.companyId,
          parentId: this.$route.query.engagementId,
          taskId: null,
          typeId: this.meetingType,
          page: this.page
        }).then((list) => {
          console.log('maaaa list', list)
          if (list.length) {
            $state.loaded();
          } else {
            console.log('$state', $state)
            $state.complete();
          }
        })
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },
      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.dynamicTags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      },
      async selectActiveMeetingNode(stateId){
        try {
          const childNode = await new Promise((resolve) => resolve(document.getElementById(stateId.toString())));
          console.log('childNode', childNode)

          if (childNode) {
            const parentContainer = await new Promise((resolve) => resolve(document.getElementById("pane-nine").parentNode));
            // get distance between blocks
            const distance = await this.countDistance(parentContainer.getBoundingClientRect(), childNode.getBoundingClientRect(), childNode.offsetTop, parentContainer.scrollTop);

            // console.log('distance', distance);
            parentContainer.scroll({
              top: distance,
              behavior: 'smooth'
            });
            // set active class to block
            await new Promise((resolve) => resolve(childNode.classList.add('hovered-node')));
            this.$store.dispatch('setStateId', null);
            setTimeout(() => {
              childNode.classList.remove('hovered-node');
            }, 3000)
          }
        } catch (err){
          console.log(err)
        }
      },
      countDistance(parent, child, childOffsetTop, parentScrollTop){
        // console.log('childOffsetTop', childOffsetTop);
        // console.log('parent-top', parent);
        // console.log('child-top', child);
        // console.log('parentScrollTop', parentScrollTop)
        // console.log('childOffsetTop', childOffsetTop)
        return new Promise ((resolve) => {
          let distance = 0;
          if (parent.top < child.top){
            // distance = (child.top +  parentScrollTop) - parent.top - childOffsetTop;
            distance = childOffsetTop
          } else if (parent.top > child.top) {
            distance = parentScrollTop - (parent.top - child.top) - parent.top
            // console.log('ma distance', distance)
            // return
          }
          resolve(distance || 0)
        })
      },
      addMeetingOpen(){
        // this.$refs.createMeetingModal.state = 'engagementMeetings.vue'
        this.$refs.createMeetingModal.openModal('create')
      },
      editTeamMeetingOpen(meeting) {
        this.$refs.editTeamMeetingModal.openModal(meeting, 'engagementMeetings')
      },
      editMeetingOpen(meetingId){
        // this.$refs.createMeetingModal.state = 'engagementMeetings.vue'
        this.$refs.createMeetingModal.openModal('update', meetingId)
      },
      hideEditMeeting(meeting){
        return this.companyLayout.companyUserId !== meeting.hostId
      },
      hideDeleteMeeting(meeting){
        return this.companyLayout.companyUserId !== meeting.hostId
      },
      changeBookMarkEngagement(state, companyId, engagementId, taskId){
        let data = this.bookmarkListEngagement
        data.meetings = !this.bookmarkListEngagement.meetings
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/setEngagement?companyId=${companyId}&engagementId=${engagementId}`, data)
          .then(response => {
            if (this.bookmarkListEngagement.meetings) {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
            } else {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
            }
          })
          .catch(error => {
          });
      },
      handleDelete(meetingId) {
        // this.$refs.createMeetingModal.state = 'projectMeetings'
        this.selectedMeetingId = meetingId
        // this.$refs.confirmation.open()

        this.$confirm(this.$t('e_tab_meetings_thisWillPermanentlyDeleteTheMeetingContinue'), this.$t('notification_title_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/meetings/delete?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.engagementId}&meetingId=${this.selectedMeetingId}&taskId=null&typeId=${this.meetingType}`)
              .then(response => {
                loader.hide()
                this.notification(this.$t('general_success'), this.$t('deleteMeeting'), "success");
                // this.$refs.confirmation.close()
                // this.$store.dispatch('getProjectMeetings')
                this.$store.dispatch('getMeetings', {
                  companyId: this.$route.query.companyId,
                  parentId: this.$route.query.engagementId,
                  taskId: null,
                  typeId: this.meetingType,
                  page: this.page})
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_deleteCanceled')
          });
        });
      },
      async refreshMeetingsList(){
        this.refreshLoading = true
        await this.$store.dispatch('getMeetings', {
          companyId: this.$route.query.companyId,
          parentId: this.$route.query.engagementId,
          taskId: null,
          typeId: this.meetingType,
          page: this.page})
        this.refreshLoading = false
      },
      clickNotes(meeting) {
        this.addNoteForm.meetingId = meeting.id
        this.$refs.addNote.open()
      },
      updateAgendaOpenModal(agenda) {
        this.updateNoteForm.agendaId = agenda.id
        this.updateNoteForm.meetingId = agenda.meetingId
        this.updateNoteForm.agenda = agenda.agenda
        this.$refs.updateNote.open()
      },
      deleteAgenda(agenda) {
        this.$confirm(this.$t('e_tab_meetings_thisWillPermanentlyDeleteTheNoteContinue'), this.$t('notification_title_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .get(`/api/v1/userMeetingAgenda/delete?userMeetingAgendaId=${agenda.id}`)
              .then(response => {
                loader.hide()
                this.notification(this.$t('general_success'), this.$t('e_tab_meetings_deleteNote'), "success");
                this.$store.dispatch('getMeetings', {
                  companyId: this.$route.query.companyId,
                  parentId: this.$route.query.engagementId,
                  taskId: null,
                  typeId: this.meetingType,
                  page: this.page})
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_deleteCanceled')
          });
        });
      },
      addNoteFormSend(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            const data = {
              agenda: this.addNoteForm.agenda
            }
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .post(`/api/v1/userMeetingAgenda/create?companyId=${this.$route.query.companyId}&meetingId=${this.addNoteForm.meetingId}`, data)
                .then(response => {
                  this.$refs.addNote.close()
                  this.notification(this.$t('general_success'), this.$t('e_tab_meetings_noteAdded'), "success");
                  this.$store.dispatch('getMeetings', {
                    companyId: this.$route.query.companyId,
                    parentId: this.$route.query.engagementId,
                    taskId: null,
                    typeId: this.meetingType,
                    page: this.page})
                  loader.hide()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                })
          }
        })
      },
      updateNoteFormSend(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            const data = {
              agenda: this.updateNoteForm.agenda
            }
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .post(`/api/v1/userMeetingAgenda/update?companyId=${this.$route.query.companyId}&meetingId=${this.updateNoteForm.meetingId}&userMeetingAgendaId=${this.updateNoteForm.agendaId}`, data)
                .then(response => {
                  this.$refs.updateNote.close()
                  this.notification(this.$t('general_success'), this.$t('e_tab_meetings_noteUpdated'), "success");
                  this.$store.dispatch('getMeetings', {
                    companyId: this.$route.query.companyId,
                    parentId: this.$route.query.engagementId,
                    taskId: null,
                    typeId: this.meetingType,
                    page: this.page})
                  loader.hide()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                })
          }
        })
      },
      startMeeting(meeting) {
        // this.$router.push(`/meetings?companyId=${this.$route.query.companyId}&token=${sessionStorage.getItem('token')}&mName=`)
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/videoChat/checkUser?companyId=${this.$route.query.companyId}&meetingId=${meeting.id}`)
            .then(response => {
              console.log(response)
              loader.hide()
              let routeData = this.$router.resolve({name: 'meetings',
                query: {
                  companyId: this.$route.query.companyId,
                  meetingId: meeting.id,
                  typeId: meeting.parentId,
                  typeName: 'engagement',
                  token: sessionStorage.getItem('token'),
                  roomId: response.data.roomId
                }
              });
              window.open(routeData.href, '_blank');
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      },
      accept(engagementMeetingId){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/meetings/approve?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.engagementId}&taskId=null&meetingId=${engagementMeetingId}&typeId=${this.meetingType}`)
          .then(response => {
            this.notification(this.$t('notification_title_success'), this.$t('notification_meeting_meetingApproved'), "success");
            this.$store.dispatch('getMeetings', {
              companyId: this.$route.query.companyId,
              parentId: this.$route.query.engagementId,
              taskId: null,
              typeId: this.meetingType,
              page: this.page})
          })
          .catch(error => {
            console.log('An error occurred:', error);
          })
      },
      tentative(engagementMeetingId) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/meetings/tentative?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.engagementId}&meetingId=${engagementMeetingId}&taskId=null&typeId=${this.meetingType}`)
            .then(response => {
              this.notification(this.$t('notification_title_success'), this.$t('notification_meeting_meetingTentative'), "success");
              this.$store.dispatch('getMeetings', {
                companyId: this.$route.query.companyId,
                parentId: this.$route.query.engagementId,
                taskId: null,
                typeId: this.meetingType,
                page: this.page})
            })
            .catch(error => {
              console.log('An error occurred:', error);
            })
      },
      decline(engagementMeetingId) {
        this.$prompt(this.$t('header_approveMeeting_reason'), this.$t('header_approveMeeting_decline'), {
          confirmButtonText: this.$t('general_ok'),
          inputValidator: (val) => {
            if (!val) return this.$t('modal_settings_fieldIsRequired')
          },
          inputErrorMessage: ''

        }).then(({ value }) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/meetings/decline?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.meetingId}&meetingId=${engagementMeetingId}&taskId=null&typeId=${this.meetingType}`, { reason: value })
              .then(response => {
                this.notification(this.$t('notification_title_success'), this.$t('success_meetingSuccessfullyDeclined'), "success");
                this.$store.dispatch('getMeetings', {
                  companyId: this.$route.query.companyId,
                  parentId: this.$route.query.engagementId,
                  taskId: null,
                  typeId: this.meetingType,
                  page: this.page})
              })
              .catch(error => {
                console.log('An error occurred:', error);
              })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_cancel')
          });
        });
      },
      isLateMeeting(meeting) {
        return meeting.startTimestamp < moment().format('X')
      },
      showLateButton(meeting){
        if (meeting.status === 1 && meeting.startTimestamp < moment().format('X') && this.companyLayout.companyUserId === meeting.hostId) {
          return true
        }
        return false
      },
      showGoToMeetingButton(companyUserId, meeting){
        // find current user in meeting
        const userMeeting = meeting.companyUserList.find(val => val.companyUserId === companyUserId)
        // check if current user is host
        const isHost = companyUserId === meeting.hostId
        // return false if user not in meeting
        if (!userMeeting) return false
        // is meeting started and user approve
        if (meeting.status === 2 && userMeeting.approved === 1 && meeting.allowTeamJoinMeeting === 0){
          return true
        }
        // if user approved and meeting without host and meeting not closed and is not host
        if (meeting.status !== 3 && userMeeting.approved === 1 && meeting.allowTeamJoinMeeting === 1 && meeting.reminderDefault === 1 && !isHost) {
          return true
        }
        // if user host and meeting started
        if (meeting.status === 2 && isHost) {
          return true
        }
        return false
      },
      openLateMeetingModal(meeting) {
        this.$refs.lateMeetingModal.openModal(meeting)
      },
      openMeeting(meeting){
        this.$confirm(this.$t('modal_areYouSureYouWantToOpenTheMeeting'), this.$t('general_info'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          const isLater = meeting.startTimestamp < moment().format('X')
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/meetings/start?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.engagementId}&taskId=null&meetingId=${meeting.id}&isLater=${isLater}&typeId=${this.meetingType}`)
              .then(response => {
                this.notification(this.$t('general_success'), this.$t('notification_meetingOpen'), "success");
                this.$store.dispatch('getMeetings', {
                  companyId: this.$route.query.companyId,
                  parentId: this.$route.query.engagementId,
                  taskId: null,
                  typeId: this.meetingType,
                  page: this.page})
                this.startMeeting(meeting)
              })
              .catch(error => {
                console.log('An error occurred:', error);
              })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_cancel')
          });
        });
      },
      closeMeeting(engagementMeetingId){
        this.$confirm(this.$t('modal_areYouSureYouWantToCloseTheMeeting'), this.$t('general_info'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/meetings/stop?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.engagementId}&meetingId=${engagementMeetingId}&taskId=null&typeId=${this.meetingType}`)
              .then(response => {
                this.notification(this.$t('general_success'), this.$t('notification_meetingStop'), "success");
                this.$store.dispatch('getMeetings', {
                  companyId: this.$route.query.companyId,
                  parentId: this.$route.query.engagementId,
                  taskId: null,
                  typeId: this.meetingType,
                  page: this.page})
              })
              .catch(error => {
                console.log('An error occurred:', error);
              })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_cancel')
          });
        });
      },
      addFiles(meeting){
        this.activeMeetingId = meeting.id
        this.$refs.fileMeetingTab.click()
      },
      handleMeetingFileTab(e) {
        let formData = new FormData();
        console.log('e.target.files[0]', e.target.files[0])
        formData.append('file', e.target.files[0]);
        formData.append('convert', 'false');

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/meeting-file/create?companyId=${this.$route.query.companyId}&entityId=${this.$route.query.engagementId}&entityTaskId=null&typeId=${this.fileMeetingType}&meetingId=${this.activeMeetingId}`,
                formData,
                {'Content-Type': 'multipart/form-data'})
            .then(response => {
              loader.hide();
              this.activeMeetingId = null
              this.$refs.fileMeetingTab.value = null
              this.$store.dispatch('getMeetings', {
                companyId: this.$route.query.companyId,
                parentId: this.$route.query.engagementId,
                taskId: null,
                typeId: this.meetingType,
                page: this.page})
            })
            .catch(error => {
              loader.hide()
              this.activeMeetingId = null
              this.$refs.fileMeetingTab.value = null
              console.log('An error occurred:', error);
            })
      },
      // viewFile(url){
      //   console.log(url)
      //   let type = url.split('.').pop().toUpperCase()
      //   if (type == 'GIF' || type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP' || type == 'OGG' || type == 'MP4' || type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A' || type == 'PDF' || type === 'XLS' || type === 'DOCX' || type === 'DOC' || type === 'XLSX') {
      //     this.fileUrl = url;
      //     this.type = this.fileUrl.split('.').pop().toUpperCase();
      //     console.log('---', this.fileUrl, this.type);
      //
      //     if (type == 'GIF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP') {
      //       this.viewerType = 2;
      //       setTimeout(() => {
      //         console.log('-----', this.$el);
      //         const viewer = this.$el.querySelector('.images').$viewer
      //         viewer.show()
      //       }, 300);
      //     } else if (type == 'OGG' || type == 'MP4') {
      //       this.viewerType = 3;
      //       setTimeout(() => {
      //         // this.$refs.video.open();
      //       }, 300);
      //     } else if (type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A') {
      //       this.viewerType = 4;
      //       setTimeout(() => {
      //         // this.$refs.video.open();
      //       }, 300);
      //     } else if (type == 'PDF') {
      //       this.viewerType = 1;
      //       this.fileUrl = process.env.VUE_APP_TF_PDF_VIEWER_BASE_URL + '/?file=' + this.fileUrl;
      //       setTimeout(() => {
      //         // this.$refs.nestedChild.open();
      //         window.open(this.fileUrl);
      //       }, 300);
      //     } else if (type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF') {
      //       // this.viewerType = 1;
      //       this.fileUrl = 'https://sharecad.org/cadframe/load?url=' + this.fileUrl;
      //       setTimeout(() => {
      //         // this.$refs.nestedChild.open();
      //         window.open(this.fileUrl);
      //       }, 300);
      //     }else if (type === 'XLS' || type === 'DOCX' || type === 'DOC' || type === 'XLSX'){
      //       const win = window.open(`https://view.officeapps.live.com/op/view.aspx?src=${this.fileUrl}`, '_blank');
      //       win.focus();
      //     }
      //   }
      // },
      closeMod() {
        this.viewerType = 0;
      },
      closeAgendaModal(){
        this.addNoteForm.agenda = null
        this.addNoteForm.meetingId = null
      },
      closeUpdateAgendaModal(){
        this.updateNoteForm.agendaId = null
        this.updateNoteForm.agenda = null
        this.updateNoteForm.meetingId = null
      },
      closeAddEmailModal() {
        this.dynamicTags = ['test@gmail.com']
        this.inputVisible = false
        this.inputValue = ''
        this.inviteLink = ''
        this.meetingName = ''
        this.meetingStartTime = ''
      },
      firstStepDone(users) {
        const currentUser = users.find(user => user.companyUserId === this.companyLayout.companyUserId);
        // if user dont exist in meeting
        if (!currentUser) {
          return true
        }
        if (currentUser.approved || currentUser.decline) {
          return true
        }
        return false
      },
      checkIfTentativeClicked(users){
        const currentUser = users.find(user => user.companyUserId === this.companyLayout.companyUserId);
        if (!currentUser) {
          return true
        }
        if (currentUser.tentative) {
          return true
        }
        return false
      },
      sendMeetingLink(meeting) {
        this.meetingName = meeting.name
        this.meetingStartTime = meeting.startTimestamp
        let routeData = this.$router.resolve({name: 'meetings',
          query: {
            companyId: this.$route.query.companyId,
            meetingId: meeting.id,
            typeId: meeting.parentId,
            typeName: 'engagement',
            publicToken: meeting.publicToken,
            roomId: meeting.roomVideoId
          }
        });
        this.inviteLink = window.location.origin + routeData.href
        this.$refs.addEmail.open()
      },
      sendMeetingLinkSubmit() {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/meetings/send-invitations?companyId=${this.$route.query.companyId}`, {
            inviteLink: this.inviteLink,
            emailArray: this.dynamicTags,
            meetingName: this.meetingName,
            meetingStartTime: moment(this.meetingStartTime, 'X').format('DD MMMM YYYY LT'),
          })
          .then(response => {
            this.notification(this.$t('general_success'), this.$t('notification_invitationsSent'), "success");
            this.$refs.addEmail.close()
          })
          .catch(error => {
            console.log('An error occurred:', error);
          })
      },
      copySharedLink(meeting) {
        let routeData = this.$router.resolve({name: 'meetings',
          query: {
            companyId: this.$route.query.companyId,
            meetingId: meeting.id,
            typeId: meeting.parentId,
            typeName: 'engagement',
            publicToken: meeting.publicToken,
            roomId: meeting.roomVideoId
          }
        });
        console.log(window.location.origin + routeData.href)

        this.$copyText(window.location.origin + routeData.href).then( (e) => {
          this.notification(this.$t('general_success'), this.$t('general_linkSuccessfullyCoppied'), "success");
        }, (e) => {
          this.notification(this.$t('general_warning'), this.$t('notification_title_error'), "success");
        })
      },
      disableClickNotesButton(agendaArr, creatorCompanyUserId) {
        return agendaArr.some((val) => val.companyUserId === this.companyLayout.companyUserId)
      },
      deleteFile(file, meeting) {
        this.$confirm(this.$t('file_meetings_thisWillPermanentlyDeleteTheFileContinue'), this.$t('general_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/meeting-file/delete?companyId=${this.$route.query.companyId}&meetingId=${meeting.id}&meetingFileId=${file.fileId}&entityId=${this.$route.query.engagementId}&entityTaskId=${null}&typeId=${this.fileMeetingType}`)
              .then(response => {
                loader.hide()
                this.notification(this.$t('general_success'), this.$t('deleteFile'), "success");
                this.$store.dispatch('getMeetings', {
                  companyId: this.$route.query.companyId,
                  parentId: this.$route.query.engagementId,
                  taskId: null,
                  typeId: this.meetingType,
                  page: this.page})
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_cancel')
          });
        });
      },
      isCurrentUserHaveAccess(agenda){
        return agenda.companyUserId ===  this.companyLayout.companyUserId
      },
      pad(num) {
        return ("0"+num).slice(-2);
      },
      secondsToHms(secs) {
        let minutes = Math.floor(secs / 60);
        secs = secs%60;
        let hours = Math.floor(minutes/60)
        minutes = minutes%60;
        return `${this.pad(hours)}:${this.pad(minutes)}`;
        // return pad(hours)+":"+pad(minutes)+":"+pad(secs); for old browsers
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      }
    }
  }
</script>

<style lang="less" scoped>
.box-card{
  margin:5px;
  .clearfix{
    display:flex;
    align-items:center;
    justify-content: space-between;
  }
  .meeting-info {
    .main-info-block {
      .team-block {
        margin:10px 0;
        max-width:450px;
        border: 1px solid #dcdfe6;
        padding: 5px;
      }
    }
    .shift-block {
      .reason-block{
        margin:10px 0;
        border: 1px solid #dcdfe6;
        padding: 5px;
      }
    }
  }

  .agenda-footer {
    display:flex;
    justify-content: flex-end;
  }
  .file__item {
    margin-top:10px;
    display:flex;
    align-items: center;
    &__viewed {
      display: flex;
      align-items: center;
      cursor: pointer;
      .file__delete {
        margin-left: 10px;
      }
    }
  }
  /deep/.el-collapse-item__header {
    padding-left:0 !important;
    color: #303133 !important;
  }
  .agenda-header {
    display:flex;
    justify-content: space-between;
    align-items:center;
  }
}
.text{
  .date{
    margin-left:10px;
  }
  .time{
    margin-left:10px;
  }
}
/deep/.box-card {
  margin: 0;
  margin-top: 20px;
}
.hovered-node{
  -webkit-box-shadow: 0 0 26px 5px #409EFF;
  box-shadow: 0 0 10px 5px #409EFF;
}

.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
